import {CHANGE_AUTH} from '../actions/constants'

export default function main(state = {}, action)
{
    switch (action.type){
        case CHANGE_AUTH:
            return Object.assign(
                {}, 
                ...state, 
                action.auth
            )
        // case 'resetUserPassword':
        //     return [ ...state, action.payload ]

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/auth.js